import Reveal from '../shared/Reveal.jsx';
import { stats } from '../constants/school.js';

export default function Numbers() {
  return (
    <section className="bg-forest py-[66px] text-mint">
      <div className="mx-auto grid max-w-[1240px] grid-cols-2 gap-x-8 gap-y-10 px-5 sm:px-8 md:grid-cols-4 md:gap-[34px]">
        {stats.map((stat, i) => (
          <Reveal key={stat.value} index={i}>
            <div className="font-display text-[clamp(38px,6vw,56px)] font-extrabold leading-none text-sun">
              {stat.value}
            </div>
            <p className="mt-1.5 text-[15.5px] leading-[1.45] text-sage">{stat.label}</p>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
